var minMaxMixin = {
	data: function () {
		return {
			combinedMessage: null,
			selectedThickness: null,
			productItem: null,
			minMaxdimensions: {
				minheight: {
					message: '',
					error: false,
				},
				maxheight: {
					message: '',
					error: false,
				},
				minwidth: {
					message: '',
					error: false,
				},
				maxwidth: {
					message: '',
					error: false,
				},
				mindiameter: {
					message: '',
					error: false,
				},
				maxdiameter: {
					message: '',
					error: false,
				},
				mintubelength: {
					message: '',
					error: false,
				},
				maxtubelength: {
					message: '',
					error: false,
				},
				minlength: {
					message: '',
					error: false,
				},
				maxlength: {
					message: '',
					error: false,
				},
			},
			units: '',
		};
	},
	methods: {
		heightFunction: function (element, fromWhere) {
			const vm = this;

			if (fromWhere == 'select') {
				vm.checkMinMax(
					'height',
					vm.product.dimensions.height,
					element.thickness.properties.height.min,
					element.thickness.properties.height.max
				);
			}

			let minMaxHeightMessage = element.thickness.properties.height.errorMessage;
			vm.minMaxdimensions.minheight.message = minMaxHeightMessage;
			vm.minMaxdimensions.maxheight.message = minMaxHeightMessage;
		},

		differentErrorMessages: function (element, fromWhere) {
			const vm = this;

			// width errors
			if (element.thickness.properties.width && document.getElementById('width')) {
				if (fromWhere == 'select') {
					vm.checkMinMax(
						'width',
						vm.product.dimensions.width,
						element.thickness.properties.width.min,
						element.thickness.properties.width.max
					);
				}

				let minMaxWidthMessage = element.thickness.properties.width.errorMessage;
				vm.minMaxdimensions.minwidth.message = minMaxWidthMessage;
				vm.minMaxdimensions.maxwidth.message = minMaxWidthMessage;

				if (element.thickness.properties.height && document.getElementById('height')) {
					vm.heightFunction(element, fromWhere);
				}
			}
			// height errors
			else if (element.thickness.properties.height && document.getElementById('height')) {
				vm.heightFunction(element, fromWhere);
			}

			// tube diameter errors
			else if (element.thickness.properties.length && document.getElementById('length')) {
				if (fromWhere == 'select') {
					vm.checkMinMax(
						'length',
						vm.product.dimensions.length,
						element.thickness.properties.length.min,
						element.thickness.properties.length.max
					);
				}
				let minMaxTubeLengthMessage = element.thickness.properties.length.errorMessage;

				vm.minMaxdimensions.mintubelength.message = minMaxTubeLengthMessage;
				vm.minMaxdimensions.maxtubelength.message = minMaxTubeLengthMessage;
			}

			// diameter errors
			else if (element.thickness.properties.diameter && document.getElementById('diameter')) {
				// rod pages where there is a diameter dropdown as well as length dimensions - skip this one then go length
				if (fromWhere != 'length') {
					if (fromWhere == 'select') {
						vm.checkMinMax(
							'diameter',
							vm.product.dimensions.diameter,
							element.thickness.properties.diameter.min,
							element.thickness.properties.diameter.max
						);
					}

					let minMaxDiameterMessage = element.thickness.properties.diameter.errorMessage;
					vm.minMaxdimensions.mindiameter.message = minMaxDiameterMessage;
					vm.minMaxdimensions.maxdiameter.message = minMaxDiameterMessage;
				}
			}
		},
		/**
		 * Updates the error messages related to product thickness dimension validation.
		 *
		 * This function is triggered when a thickness value is selected or changed.
		 * It checks the `maxMinRules` array to find matching validation rules for the selected thickness,
		 * assigns the corresponding rule to `productItem`, and then displays the appropriate error message(s)
		 * in the DOM element with ID `dimensions-minmax-error`.
		 *
		 * Depending on the number of validation errors currently displayed (based on the presence of elements
		 * with the class `is-invalid-minmax`), it will either show a combined error message or a single
		 * contextual error message based on the specific validation error type.
		 *
		 * If no valid matching rule is found, it attempts to fall back to a rule without a `key` or use
		 * the first rule in the list.
		 *
		 * @param {string|number} value - The selected thickness value to validate.
		 * @param {string} fromWhere - A context identifier indicating the source of the function call.
		 */
		getErrorMessages: function (value, fromWhere) {
			const vm = this;
			const $minmaxerror = document.getElementById('dimensions-minmax-error');

			vm.productItem = null;
			vm.selectedThickness = value;
			let matched = false;

			if (vm.maxMinRules) {
				vm.maxMinRules.forEach((element) => {
					if (element.thickness) {
						if (element.thickness.value == value) {
							matched = true;

							vm.units = vm.product.dimensions.unit;

							if (element.thickness.value == vm.selectedThickness) {
								vm.productItem = element;
							}
							vm.differentErrorMessages(element, fromWhere);
						}
					}
				});

				if (!matched) {
					vm.maxMinRules.forEach((element) => {
						if (element.thickness) {
							if (!element.thickness.key) {
								vm.units = vm.product.dimensions.unit;

								if (element.thickness.value == vm.selectedThickness) {
									vm.productItem = element;
								}

								vm.differentErrorMessages(element, fromWhere);
								return false;
							}
						}
					});
				}
			}

			// show combined error message and replace values
			if (document.querySelectorAll('.is-invalid-minmax').length > 1) {
				let hasSelectedThickness = false;
				// match selected thickness to maxMinRule
				if (vm.maxMinRules) {
					vm.maxMinRules.forEach((element) => {
						if (element.thickness.value == vm.selectedThickness) {
							vm.productItem = element;
							hasSelectedThickness = true;
						}
					});

					if (!hasSelectedThickness) {
						vm.productItem = vm.maxMinRules[0];
					}
				}

				if (vm.productItem) {
					let combinedErrorMessage = vm.productItem.thickness.properties.combinedErrorMessage;

					vm.combinedMessage = combinedErrorMessage;

					$minmaxerror.classList.remove('d-none');
					$minmaxerror.innerHTML = vm.combinedMessage;
				}
			} else if (document.querySelectorAll('.is-invalid-minmax').length == 1) {
				// match selected thickness to maxMinRule
				if (vm.maxMinRules) {
					vm.maxMinRules.forEach((element) => {
						if (element.thickness.value == vm.selectedThickness) {
							vm.productItem = element;
						}
					});
				}

				if (vm.productItem) {
					// if only 1 error
					$minmaxerror.classList.remove('d-none');
					// set error message for correct item
					const errorType = document.querySelector('.is-invalid-minmax').id;
					let singleErrorMessage = '';

					singleErrorMessage = vm.productItem.thickness.properties[errorType].errorMessage;

					$minmaxerror.innerHTML = singleErrorMessage;
					vm.combinedMessage = null;
				} else {
					// use fallback error message if there isn't one matching (the one with no key)
					const errorType = document.querySelector('.is-invalid-minmax').id;

					let singleErrorMessage = '';

					singleErrorMessage = vm.maxMinRules[0].thickness.properties[errorType].errorMessage;

					$minmaxerror.innerHTML = singleErrorMessage;
					$minmaxerror.classList.remove('d-none');

					vm.combinedMessage = null;
				}
			} else {
				if ($minmaxerror) {
					$minmaxerror.classList.add('d-none');
					$minmaxerror.innerHTML = '';
				}
				vm.combinedMessage = null;
			}
		},
		setError: function (element, minMax, message) {
			const vm = this;
			const errorItem = minMax + element.id;

			vm.minMaxdimensions[errorItem].message = message;
			vm.minMaxdimensions[errorItem].error = true;
		},
		checkMinMax: function (element, value, minVal, maxVal) {
			const vm = this;

			if (!value) {
				value = vm.product.dimensions[element];
			}

			let elementValue;
			const $element = document.getElementById(element);

			const $thickness = document.getElementById('thickness');
			const $diameter = document.getElementById('diameter');
			const errorMessage = $element.getAttribute('data-error-message');
			// elementValue = parseInt($element.value);
			elementValue = parseInt(value);

			if (minVal != null && maxVal != null) {
				if (elementValue < minVal) {
					$element.classList.add('is-invalid-minmax');
					vm.setError($element, 'min', errorMessage);
				} else if (elementValue > maxVal) {
					$element.classList.add('is-invalid-minmax');
					vm.setError($element, 'max', errorMessage);
				} else {
					$element.classList.remove('is-invalid-minmax');
				}
				if ($thickness && $thickness.value > 0) {
					vm.getErrorMessages($thickness.value, element);
				} else if ($diameter) {
					vm.getErrorMessages($diameter.value, element);
				}
			}
		},
	},
	watch: {},
};
